<template>
    <div>
        <loading :active.sync="loading.app" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link :to="{name:'auth.login'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">
                Verifikasi
            </div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <div v-if="verify_step == 1">
                <div class="section m-2 p-2">
                    <div class="text-center">
                        <h4>Pilih Metode Verifikasi</h4>
                        <small style="line-height:normal;">Pilih salah satu metode dibawah ini untuk mendapatkan kode OTP</small>
                    </div>
                    <div class="mt-3">
                        <button class="btn btn-text-primary shadowed btn-block btn-lg" v-for="item in sender" :key="item.id" @click="next_step(item.id)">{{ item.name }} ke {{ auth_data.phone }}</button>
                    </div>
                </div>
            </div>
            <div v-else-if="verify_step == 2">
                <div class="section mt-4 text-center">
                    <h1>Kode OTP</h1>
                    <h4>Masukkan 6 digit kode OTP</h4>
                </div>
                <div class="section mb-5 p-2">
                    <form action="app-index.html">
                        <div class="form-group basic">
                            <input type="number" class="form-control verification-input" placeholder="••••••"
                                maxlength="6" v-model="auth_data.verification_code">
                        </div>
                        <div class="mt-3 text-center">
                            <div style="font-size:12px;;">
                                Belum dapat kode OTP? <br>
                                <a v-if="countDown == 0" @click="resend_code" style="cursor:pointer;" class="text-primary">
                                    <b>Kirim Ulang</b>
                                </a>
                                <b v-else class="text-default">Kirim Ulang dalam {{ countDown }} detik</b>
                            </div>
                        </div>
                        <div class="form-button-group mx-width shadow-header-footer">
                            <ButtonLoader :loading="loading.button" :styled="'btn btn-primary btn-block btn-lg'" @click.native="submit()">Validasi</ButtonLoader>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
export default {
    name: 'auth.login.verify',
    data() {
        return {
            verify_step: 1, 
            countDown: 60
        }
    },
    created(){
        this.$store.commit('SET_LOADING', {app:true,button:false})
        if (this.isAuth) {
            this.$router.push({ name: 'home' })
        }
        this.getSender().then(() => {
            this.$store.commit('SET_LOADING', {app:false})
        }).catch(() => {
            this.$store.commit('SET_LOADING', {app:false})
        })
    },
    computed:{
        ...mapGetters(['isAuth']),
        ...mapState(['loading','toast']),
        ...mapState('auth',{
            sender: state => state.sender,
            auth_data: state => state.auth_data,
        }),
    },
    methods:{
        ...mapActions('auth', ['getSender','requestCode','verifyCode']),
        ...mapMutations('auth',['RESET_AUTH_DATA']),
        next_step(id){
            this.$store.commit('SET_LOADING', {app:true})
            this.$store.commit('SET_TOAST', {show:false})
            this.requestCode({id:id, phone:this.auth_data.phone}).then(() => {
                this.$store.commit('SET_LOADING', {app:false})
                this.verify_step = 2
                this.countDown = 60
                this.countDownTimer()
            }).catch((error) => {
                this.$store.commit('SET_LOADING', {app:false})
                this.$store.commit('SET_TOAST', {show:true,message:error.data.message,tipe:'default',icon:'danger'})
            })
        },
        submit(){
            this.$store.commit('SET_LOADING', {button:true})
            this.$store.commit('SET_TOAST', {show:false})
            this.verifyCode().then((response) => {
                this.$store.commit('SET_LOADING', {button:false})
                if (this.isAuth) {
                    this.$router.push({ name: 'home', query:{session_id:response.session_id}})
                }else{
                    this.$router.push({ name: 'auth.login' })
                }
            }).catch((error) =>{
                this.$store.commit('SET_LOADING', {button:false})
                this.$store.commit('SET_TOAST', {show:true,message:error.data.message,tipe:'default',icon:'danger'})
            })
        },
        countDownTimer() {
            if(this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            }
        },
        resend_code(){
            this.verify_step = 1
        }
    },
    mounted() {
        if(this.auth_data.phone == '' && this.auth_data.verification_code == ''){
            this.$router.push({ name: 'auth.login' })
        }
        document.body.classList.add('bg-white')
    },
    destroyed() {
        this.$store.commit('RESET_LOADING')
        this.$store.commit('RESET_TOAST')
        this.RESET_AUTH_DATA()
    },
}
</script>